import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import useLocalStorage from './useLocaleStorage';

export default function useHistoryWithToken() {
	const [localToken] = useLocalStorage('localToken');
	const history = useHistory();
	const push = useCallback((url) => history.push(`${url}/${localToken}`), [history, localToken]);

	return { ...history, push };
}
